import React, { useId } from 'react';
import MLIcon from '../../../../../../components/MLIcon/MLIcon';
import s from './InsightsSelect.module.css';
import { getInsightsTag } from '../../helpers';
import { INSIGHTS_MENU } from '../../../../constants';

export const AssignmentPerformanceSelect = ({
  onChange,
  placeholder,
  assignments,
  isGrs,
  selectedAssignmentId,
}) => {
  const handleChange = (e) => {
    const selectedIndex = e.target.value;
    const selectedAssignment = assignments[selectedIndex];
    if (selectedAssignment) {
      onChange(selectedAssignment);
    }
  };

  const selectId = useId();

  return (
    <div className={s.wrapper}>
      <label htmlFor={selectId}>Results for: </label>
      <div
        className={s.selectContainer}
        data-test-id={`${getInsightsTag(
          isGrs ? INSIGHTS_MENU.GRS : INSIGHTS_MENU.ASSIGNMENT_PERFORMANCE
        )}-dropdown`}
      >
        <MLIcon className={s.icon} type="document_check" />
        <select 
          id={selectId}
          className={s.select} 
          onChange={handleChange}
          aria-label="Select assignment for results"
        >
          {placeholder && (
            <option value="" disabled>
              {placeholder}
            </option>
          )}
          {assignments.map((assignment, index) => (
            <option
              key={assignment.value}
              value={index}
              selected={selectedAssignmentId === assignment.value}
            >
              {assignment.label || assignment.name || assignment.title}
            </option>
          ))}
        </select>
        <MLIcon className={s.caret} type="caret_down" />
      </div>
    </div>
  );
};
